<template>
  <div class="kat-list-item row">
    <div class="col-xs-12 col-lg-12 spacer-top text-right d-lg-none">
      <hr>
      <button type="button" class="favorite-button" @click="$emit('toggle-favorite')">
        <img v-if="favorite" src="@/img/save-checked.svg" alt="✅️">
        <img v-else src="@/img/save-unchecked.svg" alt="☑️️">
      </button>
    </div>
    <div class="col-xs-5  col-lg-12 text-center">
      <div class="embed-responsive" style="padding-bottom: 75%">
        <div class="embed-responsive-item">
          <combined-image
              :filename="getDefaultImage(item.images)"
              :user-id="watermark"
              @process-img="forwardProcessImgEvent"
              @start-zooming="$emit('enlarge-img', $event)"

              style="height: 100%"
          ></combined-image>
        </div>
      </div>
    </div>
    <div class="col-xs-7 col-lg-12">
      <div class="lg-card-warp">
        <button type="button"
                class="d-xs-none d-lg-block favorite-button"
                style="margin-right: 10px"
                @click="$emit('toggle-favorite')">
          <img v-if="favorite" src="@/img/save-checked.svg" alt="✅️">
          <img v-else src="@/img/save-unchecked.svg" alt="☑️️">
        </button>
        <h3>{{ translateConverter(item) }}</h3>
        <template v-if="item.inscriptions">
          <b>{{ _('Erkennungsmerkmal:') }} </b><br>{{ inscriptionForItem(item) || _('N/A') }}<br>
        </template>
        <button class="detail-button" @click="$emit('open',item.id)">{{ _('Wert / Details') }}</button>
        <div class="spacer-top" @click.stop>
          <slot/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ForwardEvents from '../mixins/forwardEvents'

import CombinedImage from './CombinedImage'

export default {
  name: 'KatListItem',
  mixins: [ForwardEvents],
  components: { CombinedImage },
  props: {
    item: { type: Object, default: () => ({}) },
    favorite: { type: Boolean, default: false },
    watermark: { type: String },
  },
  computed: {},
  methods: {
    getDefaultImage (images) {
      let defaultImage = images.find(el => el.default)

      if (defaultImage) {
        return defaultImage.id
      }

      if (images.length > 0) {
        return images[0].id
      }

      return null
    },
    inscriptionForItem (item) {
      return item.inscriptions
          .filter(inscription => inscription.identifying)
          .map(inscription => {
            return this.translateInscription(inscription)
          }).join(', ')
    },
  },
}
</script>
